import { render, staticRenderFns } from "./staff-side-bar.vue?vue&type=template&id=65aaaa39&"
import script from "./staff-side-bar.vue?vue&type=script&lang=js&"
export * from "./staff-side-bar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports